
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState } from "react";
import { ClientForm } from "./ClientForm";

interface CreateClientDialogProps {
  onClientCreated: () => void;
}

export const CreateClientDialog = ({ onClientCreated }: CreateClientDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="mb-6">
          <Plus className="h-4 w-4 mr-2" />
          Add New School
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Create New School</DialogTitle>
        </DialogHeader>
        <ClientForm
          onSuccess={() => {
            onClientCreated();
            setOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
